import React from 'react';
import PropTypes from 'prop-types';

class Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            imgSrc,
            iStyle,
            iClassName,
            alt,
        } = this.props;
        return (<div className={['imgBox', iClassName].join(" ")} style={iStyle}><img src={imgSrc} alt={alt}/></div>)
    }
}


Image.defaultProps = {
    iStyle: {},
    iClassName: '',
    alt: '',
};
Image.propTypes = {
    imgSrc: PropTypes.any.isRequired,
    iClassName: PropTypes.string,
    alt: PropTypes.string,
    iStyle: PropTypes.object,
};

export default Image;